import { ArrowRight } from "lucide-react";
import { MessageCircle } from "lucide-react";
import Reveal from "../components/Reveal";
import { IMG, WHATSAPP_LINK } from "../data/content";
import { openEnquiry } from "../components/Header";

export default function FinalCta() {
  return (
    <section data-testid="final-cta-section" className="relative flex min-h-[90vh] items-center justify-center overflow-hidden">
      <img
        src={IMG.misty}
        alt="Barbets perched in the forest at The Jamoon in Corbett"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal/80 via-charcoal/60 to-charcoal/90" />
      <div className="relative z-10 px-6 py-24 text-center">
        <Reveal>
          <img
            src="/logo-full.png"
            alt="JAMOON — Corbett's Best Kept Secret"
            className="mx-auto h-20 w-auto sm:h-24"
          />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-serif text-4xl font-light leading-tight tracking-tight text-ivory sm:text-6xl lg:text-7xl">
            Ready to <span className="italic text-brass">walk in?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="font-serif text-lg italic text-ivory/80 sm:text-xl">
            Walk on the footsteps of Jim Corbett.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <button
              data-testid="final-plan-journey-btn"
              onClick={openEnquiry}
              className="group flex items-center gap-3 bg-brass px-9 py-4 text-xs font-semibold tracking-[0.28em] text-charcoal transition-colors duration-500 hover:bg-[#B89B6A]"
            >
              PLAN YOUR JAMOON JOURNEY
              <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1.5" />
            </button>
            <a
              data-testid="final-whatsapp-btn"
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 border border-ivory/40 px-9 py-4 text-xs font-semibold tracking-[0.28em] text-ivory transition-colors duration-500 hover:border-brass hover:text-brass"
            >
              <MessageCircle className="h-4 w-4" /> WHATSAPP
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
